import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    AttributeTypeParams,
    AttributeTypes,
    getAttributeValues,
} from "@tSurya/Services/CartPlaceOrder/getAttributeService";

import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<AttributeTypeParams & HasOnSuccess & HasOnError, AttributeTypes>;

export const DispatchGetAttributeValue: HandlerType = props => {
    props.dispatch({
        type: "Data/AttributeValues/BeginLoadAttributeValues",
        params: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAttributeValues(props.apiParameter);
    } catch (error) {
        if (isApiError(error)) {
            props.parameter.onError?.(error.errorJson.message);
            props.dispatch({
                type: "Data/AttributeValues/CompleteLoadAttributeValues",
                result: props.apiResult,
            });
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult as any);
};

export const DispatchCompleteGetAttributeValue: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }
    props.dispatch({
        type: "Data/AttributeValues/CompleteLoadAttributeValues",
        result: props.apiResult,
    });
};

export const chain = [
    DispatchGetAttributeValue,
    PopulateApiParameter,
    RequestDataFromApi,
    ExecuteOnSuccessCallback,
    DispatchCompleteGetAttributeValue,
];

const getAttributeValuesData = createHandlerChainRunner(chain, "getAttributeValuesData");

export default getAttributeValuesData;
